import { v1 } from "@/axios"

interface IAbortMultipartUploadData {
  uploadId: string
  key: string
}
export async function abortMultipartUpload(data: IAbortMultipartUploadData, eventVaultId: number) {
  return v1.post(`/upload/${eventVaultId}/multipart/abort`, data)
}
